import { render, staticRenderFns } from "./returnVisit-popup-view.vue?vue&type=template&id=a4b72a9a&scoped=true&"
import script from "./returnVisit-popup-view.vue?vue&type=script&lang=js&"
export * from "./returnVisit-popup-view.vue?vue&type=script&lang=js&"
import style0 from "./returnVisit-popup-view.vue?vue&type=style&index=0&id=a4b72a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b72a9a",
  null
  
)

component.options.__file = "returnVisit-popup-view.vue"
export default component.exports